export default "__VITE_ASSET__4ec32b11__"